export function transposeChord(chord, halfSteps) {
    // Define chromatic scale with sharps
    const notesSharp = ["C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#", "B"];
    // Define equivalent flats for matching input
    const notesFlat  = ["C", "Db", "D", "Eb", "E", "F", "Gb", "G", "Ab", "A", "Bb", "B"];

    // Match chord root (like "C#", "Db", "G") and remainder (like "maj7", "m", "sus4", etc.)
    const match = chord.match(/^([A-G][b#]?)(.*)$/);
    if (!match) return chord; // Invalid chord format — return as-is

    const [, root, suffix] = match;

    // Normalize to sharp scale for internal math
    let index = notesSharp.indexOf(root);
    if (index === -1) index = notesFlat.indexOf(root);
    if (index === -1) return chord; // Not found in either list

    // Calculate new note index
    let newIndex = (index + halfSteps) % 12;
    if (newIndex < 0) newIndex += 12;

    // Choose naming convention based on input
    const useFlats = root.includes('b');
    const newRoot = useFlats ? notesFlat[newIndex] : notesSharp[newIndex];

    return newRoot + suffix;
}

export function renderChordLine(chordLineData, minWidth = 0) {
    if (!Array.isArray(chordLineData) || chordLineData.length === 0) {
        return ' '.repeat(minWidth);
    }

    // Sort by position just in case
    const sorted = [...chordLineData].sort((a, b) => a.position - b.position);

    let output = '';
    let cursor = 0;

    for (const { chord, position } of sorted) {
        const gap = position - cursor;
        if (gap > 0) output += ' '.repeat(gap);
        output += chord;
        cursor = position + chord.length;
    }

    // pad to desired width
    if (cursor < minWidth) output += ' '.repeat(minWidth - cursor);

    return output;
}

